import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { get as _get } from 'lodash';
// rxjs
import { of } from 'rxjs';
import { mergeMap, withLatestFrom } from 'rxjs/operators';

import { fromRouterActions } from '@amfam/shared/utility/navigation';
import {
  fromProgressIndicatorActions,
  progressIndicatorQuery,
  ProgressIndicatorState,
  Step
} from '@amfam/ui-kit';

import { PostFnolRoutingService } from '../services/post-fnol-routing.service';
import { NextStep, PostFnolActionTypes, SkipStep } from './post-fnol.actions';
import { PostFnolState } from './post-fnol.reducer';
import { postFnolQuery } from './post-fnol.selectors';

@Injectable()
export class PostFnolEffects {
  nextStep$ = createEffect(() =>
    this.action$.pipe(
      ofType<NextStep>(PostFnolActionTypes.NextStep),
      withLatestFrom(
        this.progressIndicatorStore.select(progressIndicatorQuery.selectProgressIndicatorData),
        this.postFnolStore.select(postFnolQuery.getPostFnolState)
      ),
      mergeMap(([action, steps, postFnolState]) => {
        const activeStep: Step = steps.find(step => step.active);
        const nextStep = _get(activeStep, 'nextStep');
        const path = this.routingService.getStepRoutePath(
          nextStep,
          postFnolState.claimNumber,
          postFnolState.context
        );
        return of(
          fromProgressIndicatorActions.ProgressIndicatorStepNext(),
          fromRouterActions.Go({
            path: path
          })
        );
      })
    )
  );

  skipStep$ = createEffect(() =>
    this.action$.pipe(
      ofType<SkipStep>(PostFnolActionTypes.SkipStep),
      withLatestFrom(
        this.progressIndicatorStore.select(progressIndicatorQuery.selectProgressIndicatorData),
        this.postFnolStore.select(postFnolQuery.getPostFnolState)
      ),
      mergeMap(([action, steps, postFnolState]) => {
        const activeStep: Step = steps.find(step => step.active);
        const nextStep = _get(activeStep, 'nextStep');
        const path = this.routingService.getStepRoutePath(
          nextStep,
          postFnolState.claimNumber,
          postFnolState.context
        );
        return of(
          fromProgressIndicatorActions.ProgressIndicatorSkip(),
          fromRouterActions.Go({
            path: path
          })
        );
      })
    )
  );

  constructor(
    private progressIndicatorStore: Store<ProgressIndicatorState>,
    private postFnolStore: Store<PostFnolState>,
    private action$: Actions,
    private routingService: PostFnolRoutingService
  ) {}
}
